<template>
  <div>
    <div id="Flexible">
      <h1>flexible season membership</h1>
      <div class="line"></div>
      <b-container fluid class="wrapper">
        <div style="overflow-x: auto">
          <table>
            <thead>
              <tr class="tableHeader">
                <th colspan="7">Flexible Rays Season Membership</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Investment</th>
                <th>$750+</th>
                <th>$2,000+</th>
                <th>$4,000+</th>
                <th>$8,000+</th>
                <th>$12,000+</th>
                <th>$20,000+</th>
              </tr>
              <tr>
                <td>Ticket Discount Tier</td>
                <td>Bronze</td>
                <td>Bronze</td>
                <td>Silver</td>
                <td>Gold</td>
                <td>Gold</td>
                <td>Platinum</td>
              </tr>
              <tr>
                <td>Available Seat Locations</td>
                <td><div class="square green"></div></td>
                <td>
                  <div class="square green"></div>
                  <div class="square lightBlue"></div>
                </td>
                <td>
                  <div class="square green"></div>
                  <div class="square lightBlue"></div>
                  <div class="square blue"></div>
                </td>
                <td>
                  <div class="square green"></div>
                  <div class="square lightBlue"></div>
                  <div class="square blue"></div>
                  <div class="square orange"></div>
                </td>
                <td>
                  <div class="square green"></div>
                  <div class="square lightBlue"></div>
                  <div class="square blue"></div>
                  <div class="square orange"></div>
                  <div class="square yellow"></div>
                </td>
                <td>
                  <div class="square green"></div>
                  <div class="square lightBlue"></div>
                  <div class="square blue"></div>
                  <div class="square orange"></div>
                  <div class="square yellow"></div>
                </td>
              </tr>
              <tr>
                <td>Parking Discounts</td>
                <td><img src="@/assets/icons/logomark-alt.svg" /></td>
                <td><img src="@/assets/icons/logomark-alt.svg" /></td>
                <td><img src="@/assets/icons/logomark-alt.svg" /></td>
                <td><img src="@/assets/icons/logomark-alt.svg" /></td>
                <td><img src="@/assets/icons/logomark-alt.svg" /></td>
                <td>Complimentary</td>
              </tr>
              <tr>
                <td>Exclusive Presales</td>
                <td><img src="@/assets/icons/logomark-alt.svg" /></td>
                <td><img src="@/assets/icons/logomark-alt.svg" /></td>
                <td><img src="@/assets/icons/logomark-alt.svg" /></td>
                <td><img src="@/assets/icons/logomark-alt.svg" /></td>
                <td><img src="@/assets/icons/logomark-alt.svg" /></td>
                <td><img src="@/assets/icons/logomark-alt.svg" /></td>
              </tr>
            </tbody>
          </table>
          <p class="small">
            *Discounts, estimated to be between 0 – 30%, will vary depending on
            games selected and membership tier. Platinum discounted ticket pricing
            will be the largest discount, followed by Gold, Silver, then Bronze.
          </p>
        </div>
        <!-- <p class="smallPrint">*Discounts will vary depending on games selected and Membership Level. Gold discounted ticket pricing will be the largest discount, followed by Silver, then Bronze.</p> -->
      </b-container>
      <Seating />
    </div>
    <Banner bannerDivider="second" />
  </div>
</template>

<script>
import Seating from "../Seating/Seating.vue";
import Banner from "@/components/sections/Banner/Banner";
export default {
  components: { Seating, Banner },
  name: "Flexible",
};
</script>

<style lang="scss" scoped>
#Flexible {
  /* text-align: center; */
  margin: auto;
  padding: 150px 0 100px;
  background-image: url("~@/assets/images/welcome/bgImage_gray.jpg");
  background-size: cover;
  @media only screen and (max-width: $md) {
    padding-block: 50px;
  }
  .line {
    background-color: $yellow;
    width: 560px;
    height: 5px;
    margin: 15px auto 1em;
    @media only screen and (max-width: $sm) {
      width: 80%;
    }
  }
  h1 {
    font-family: "Antique Olive";
    font-style: normal;
    text-align: center;
    font-weight: 700;
    font-size: 35px;
    line-height: 80%;
    text-transform: uppercase;
    color: #00285e;
    @media only screen and (max-width: $sm) {
      line-height: 1;
      font-size: 25px;
    }
  }
  .wrapper {
    max-width: 1024px;
  }
  table {
    width: 100%;
    margin-top: 50px;
    font-family: "Futura";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    background: #dad9d7;
    /* identical to box height */

    text-align: center;

    /* gray light */
    @media only screen and (max-width: $lg) {
      zoom: 0.9;
    }
    @media only screen and (max-width: $md) {
      zoom: 0.7;
    }
    @media only screen and (max-width: $sm) {
      zoom: 0.6;
    }
    thead {
      background-color: $dark-blue;
      color: #fff;
      font-size: 21px;
    }
    .tableHeader {
      th {
        font-family: "Futura";
        font-style: normal;
        font-weight: 500;
        font-size: 22px;

        line-height: 59px;
        text-align: center;
        color: #dad9d7;
      }
    }
    tr {
      height: 45px;
      border-bottom: 1px solid #fff;
      th {
        border-left: 1px solid #fff;
      }
      td {
        border-left: 1px solid #fff;
        img {
          width: auto;
          margin: auto;
        }
        .square {
          display: inline-block;
          width: 20px;
          height: 20px;
          margin: auto;
          border: 1px solid #d9d9d9;
          position: relative;
          top: 5px;
          &.green {
            background-color: #005f35;
          }
          &.lightBlue {
            background-color: #79bde8;
          }
          &.blue {
            background-color: #00285d;
          }
          &.orange {
            background-color: #f78f1e;
          }
          &.yellow {
            background-color: #fcd20b;
          }
          &.black {
            background-color: #050707;
          }
        }
      }
    }
    tr:nth-child(even) {
      background: #b9b9b9;
    }
  }
  p.small {
    font-family: "Futura";
    font-style: italic;
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    color: #161e26;
    margin-top: 20px;
  }
}
</style>
